// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk.semi-input-wrapper {
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk .semi-input-prepend {
  border-top: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-bottom: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-left: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  background: var(--light-usage-disabled-color-disabled-fill, rgba(46, 46, 56, .04));
  padding: 0 12px;
}

.\\------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk .semi-input-prepend.semi-input-prepend-text {
  border-top: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-bottom: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-left: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  background: var(--light-usage-disabled-color-disabled-fill, rgba(46, 46, 56, .04));
  padding: 0 12px;
}

.\\------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk .semi-input-append {
  border-top: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-bottom: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-left: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  background: var(--light-usage-disabled-color-disabled-fill, rgba(46, 46, 56, .04));
  padding: 0 12px;
}

.\\------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk .semi-input-append.semi-input-append-text {
  border-top: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-bottom: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  border-left: 1px solid var(--light-usage-border-color-border, rgba(29, 28, 35, .08));
  background: var(--light-usage-disabled-color-disabled-fill, rgba(46, 46, 56, .04));
  padding: 0 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-input": `------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk`,
	"uiInput": `------packages-components-bot-semi-src-components-ui-input-index-module__ui-input-WYouJk`
};
export default ___CSS_LOADER_EXPORT___;
